import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from "./Navbar";
import Footer from "./Footer";
// import CustomCursor from "../Components/CustomCursor"; 

const Disclaimer = () => {
    const navStyle = {
        backgroundColor: "#f0f0f0",
        padding: "12px 12px 12px 5%",
        borderRadius: "5px",
      };
    
      const ulStyle = {
        listStyleType: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        alignItems: "center",
        fontSize: "11px",
      };
    
      const liStyle = {
        marginRight: "6px",
      };
    
      const linkStyle = {
        textDecoration: "none",
        color: "#000",
        cursor:"pointer "
      };
    
  const containerStyle = {
    padding: '1% 5% 3% 5%',
    backgroundColor:"rgb(232, 240, 238)",
    color:"rgb(93, 64, 55)"

  };

  const headingStyle = {
    fontSize: '30px',
  };

  const paragraphStyle = {
    lineHeight: '1.8',
    textAlign: 'justify',
    marginTop: '30px',
  };

  const navigate = useNavigate();
  const Home = () => {
    navigate("/")
  }

  return (
    <>
    <div>
    {/* <CustomCursor/> */}
    <Navbar />
    <section>
      <nav style={navStyle}>
        <ul style={ulStyle}>
          <li style={liStyle}>
            <a onClick={Home} style={linkStyle}>HOME</a>
          </li>
          <li style={liStyle}>&gt;</li>
          <li>
            <a style={linkStyle}>WEBSITE DISCLAIMER</a>
          </li>
        </ul>
      </nav>
    </section>
    <div className="disclaimer-content" style={containerStyle}>
      <h1 style={headingStyle}>WEBSITE DISCLAIMER</h1>
      <p style={paragraphStyle}>
        The information contained in this website is for general information purposes only. 
        The information is provided by <strong>bharatarakucoffee.com</strong>, a property of 
        MagicRoast Qoffee Private Limited (MAGICROAST QOFFEE). While we endeavor to keep the 
        information up to date and correct, we make no representations or warranties of any kind, 
        express or implied, about the completeness, accuracy, reliability, suitability or availability 
        with respect to the website or the information, products, services, or related graphics contained 
        on the website for any purpose. Any reliance you place on such information is therefore strictly 
        at your own risk.<br /><br />
        In no event will we be liable for any loss or damage including without limitation, indirect or 
        consequential loss or damage, or any loss or damage whatsoever arising from loss of data or 
        profits arising out of, or in connection with, the use of this website.<br /><br />
        At various points throughout the site you may be offered automatic links to other internet 
        sites relevant to a particular aspect of this site. We have no control over the nature, content 
        and availability of those sites. The inclusion of any links does not necessarily imply a 
        recommendation or endorse the views expressed within them.<br /><br />
        Every effort is made to keep the website up and running smoothly. However, MAGICROAST QOFFEE 
        takes no responsibility for, and will not be liable for, the website being temporarily unavailable 
        due to technical issues beyond our control.
      </p>
    </div>
    <Footer />
    </div>
    </>
  );
};

export default Disclaimer;
